"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTable = void 0;
const react_1 = __importStar(require("react"));
const Button_1 = require("./Button");
exports.CardTable = react_1.default.memo(({ className, data = [], totalCount = 0, groupSize = 4, renderTitle, renderEmpty, renderCard, getKey, showMoreLabel, handlerLoadMore, isLoadingMore = false, }) => {
    const totalGroup = (0, react_1.useMemo)(() => Math.max(1, Math.ceil((totalCount || 0) / groupSize)), [totalCount, groupSize]);
    const currentGroup = (0, react_1.useMemo)(() => Math.max(1, Math.ceil((data?.length || 0) / groupSize)), [data, groupSize]);
    const hasMore = data.length < totalCount;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        renderTitle,
        react_1.default.createElement("div", { className: `card-table ${className || ''}` },
            react_1.default.createElement("div", { className: "card-table-content" }, totalCount <= 0
                ? renderEmpty
                : data.map((item, index) => (react_1.default.createElement(react_1.default.Fragment, { key: getKey ? getKey(item, index) : item?.id || index }, renderCard(item, index))))),
            hasMore && (react_1.default.createElement("div", { className: "card-table-more-wrap" },
                react_1.default.createElement(Button_1.Button, { className: "btn_white xmd fit_btn card-table-more", text: showMoreLabel
                        ? showMoreLabel(currentGroup, totalGroup)
                        : `더보기 (${currentGroup}/${totalGroup})`, onClick: isLoadingMore
                        ? undefined
                        : () => handlerLoadMore && handlerLoadMore(currentGroup + 1) }))))));
});
